<!--app store-->
<template>
  <a :href="href" target="_blank" class="app-store-wrapper">
    <slot>
      <i :class="app" class="zr-icons" />
    </slot>
  </a>
</template>

<script>
import config from '../../../../static/config/config.js'
export default {
  name: 'AppStore',
  props: {
    app: {
      type: String,
      default: 'ios' // 客户端： ios/andirod
    }
  },
  data () {
    return {}
  },
  computed: {
    href() {
      return config.appStore[this.app] || ''
    }
  }
}
</script>
<style lang="scss" scoped>
.app-store-wrapper {
  display: inline-block;
  position: relative;
  .zr-icons {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    &.ios {
      width: 13px;
      height: 16px;
    }
    &.android {
      width: 14px;
      height: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/appStore/index.vue